module.exports = __webpack_public_path__ + "frontend-assets/img/cosmote-offer.8447c39b.png";